<template>
  <div class="SX">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoRisk">首页></span>
        <span @click="GoSiXiang">巡视巡察></span>
        <span @click="GoJT">集团动态></span>
        <span class="red">正文</span>
      </div>
      <!-- 正文 -->
      <div class="zhengwen">
        <h1>“五优化”有效破解巡察工作难题</h1>
        <div class="first">
        <span class="third">来源：新华社</span>
         <span class="si">|</span>
        <span>发布时间：2020-5-20 13:30</span>
      </div>
       <div class="xh"></div>
        <div class="second">
          <p>为全面贯彻全国市县巡察工作推进会精神，崇信县委巡察工作领导小组立即召开会议，研究当前巡察工作现状，分析存在的突出问题，优化巡察工作思路，破解巡察工作难题，确保巡察工作有力有序有效开展。</p>

          <strong>
            <p>一是优化巡察内容设置，破解重点不突出、力量分散的问题。</p>
          </strong>

          <p>每轮巡察工作内容设置，都实行模块式管理，在坚持“六个围绕”、“一个加强”的基础上，结合近期中央、省市县委重大决策部署活动和各行业特点，详细列出巡察的重点领域和行业性风险点；在巡察对象的确定上，区分行业类型，突出主攻方向，将一个系统或管理服务职能较为接近的单位，列在同一轮进行巡察；在巡察人员配备上，配齐配强行业性、专业性人才。县委第二轮巡察，对教科局、学区、学校进行整合，开展了常规加专项巡察；正在开展的县委第三轮巡察，又将卫健局、疾病预防控制中心、医院等单位进行了整合，分在一个巡察组进行巡察，推动了巡察工作高效开展。</p>

          <p></p>
          <strong>
            <p>二是优化巡察组织方式，破解面广量大、灵活性不足的问题。</p>
          </strong>

          <p>积极探索创新出常规巡察镶嵌专项巡察的方式，县委第二轮巡察在开展常规巡察的同时嵌入教育系统专项巡察，第三轮巡察在常规巡察中嵌入国有企业专项巡察和巡察“回头看”。“常规巡”突出政治站位，聚焦党的领导、党的建设、全面从严治党、党风廉洁建设和反腐败工作，看被巡察党组织的领导核心作用发挥得够不够、领导班子凝聚力强不强，是不是与中央和省市县委保持高度一致，是不是在管党治党上体现“严”的要求。“专项巡”精准监督发力，紧贴县委县政府重大任务、重点领域及阶段性重点工作推进情况进行监督，做到县委中心工作部署到哪里，巡察监督就跟进到哪里，哪里问题突出就巡察那里，做到对象“精准定位”、内容“精准定向”、方式“精准发力”。通过“镶嵌式”巡察，既突出了常规巡察的全面性，又体现了专项巡察的灵活性，做到了“常”中有“专”、“专”中有“常”。</p>
          <strong>
            <p>三是优化巡察组工作方法，破解察的不深、不透、不实的问题。</p>
          </strong>
          <p>探索推行“听、问、谈、查、摸”五工作法。即：听取汇报“听”问题，主要听取被巡察党组织在履行全面从严治党主体责任、执行党的纪律等方面汇报；个别谈话“问”问题，主要了解掌握群众关注的脱贫攻坚、项目建设等领域问题，发现和掌握有价值的线索；召开会议“谈”问题，主要通过召开各个领域的座谈会，征求意见建议，发现甄别问题；查阅资料“查”问题，主要查阅“三重一大”事项、重大决策部署贯彻落实等方面资料；走访调研“摸”问题，主要是深入村社农户，对政策落实、干部作风等情况进行调查，面对面听取群众意见。通过五工作法开展巡察，切实做到问题查找全面，线索了解评估精准。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    GoRisk() {
      this.$router.push("/HOME");
    },
    GoSiXiang() {
      this.$router.push("/MakeInspectionTour");
    },
   GoJT() {
      this.$router.push("/MakeInspectionTour/JiTuan");
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}
p:nth-child(1) {
  text-indent: 0;
}
h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.si{
   margin: 0 16px;
 }
</style>